import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import {action, computed} from 'mobx';
import {inject} from 'mobx-react';
import {Link} from 'react-router';

import {withI18n} from 'spa/Components/Context';

import ProgressiveBackgroundImage from 'spa/Components/ProgressiveBackgroundImage';
import ProgressiveImage from 'spa/Components/ProgressiveImage';

import 'spa/styles/home.less';
import '../../Home/HomeTreatmentsSection.less';

@inject(({store: {screen, tracker}}) => ({
  screen,
  tracker,
}))
@withI18n
class HomeTreatmentsSectionForDigital extends React.Component {
  static propTypes = {
    screen: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }),
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    trackingCategory: PropTypes.string,
    trackingLocation: PropTypes.string,
  };

  @autobind
  @action('onClickBrowseServices - HomeTreatmentsSectionForDigital')
  onClickBrowseServices() {
    const trackingData = {
      category: this.props.trackingCategory,
      label: 'Browse Services',
    };

    if (this.props.trackingLocation) {
      trackingData.data = {
        page: this.props.trackingLocation,
      };
    }

    this.props.tracker.track('Clicked Browse Services button', trackingData);
  }

  @computed get brandsSectionContent() {
    const {i18n} = this.context;

    if (i18n.umRegion === 'UK') {
      return (
        <React.Fragment>
          <p className="home-content-section__paragraph home-content-section-for-digital__paragraph">Think long-lasting nail treatments from CND, facials from the skincare masters, Dermalogica, and massages to suit your mood from Neom Organics.</p>
          <p className="home-content-section__paragraph home-content-section-for-digital__paragraph">Book in-person (when measures allow) or get expert advice by two-way video.</p>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <p className="home-content-section__paragraph home-content-section-for-digital__paragraph">{i18n._x('Our mission is to empower city dwellers to put wellness first, with tailored at-home services.', 'Home treatments section paragraph')}</p>
        <p className="home-content-section__paragraph home-content-section-for-digital__paragraph">{i18n._x('Book in-person (when measures allow) and by two-way video – for personalised massage, beauty, yoga, meditation and more.', 'Home treatments section paragraph')}</p>
      </React.Fragment>
    );
  }

  render() {
    const {i18n} = this.context;
    const {screen: {isDesktop}} = this.props;
    const {brandsSectionContent} = this;

    return (
      <div className="home-treatments-section home-content-section row">
        <ProgressiveBackgroundImage
          customClass="home-content-section__cell home-content-section__cell-image home-content-section-for-digital__cell-image home-treatments-section__cell-image"
          lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1585840680/b2c-art/home-2020/digital/img_homepage_videocall_1x.jpg"
          highResImg=""
          highResImg2x=""
          mediaQueries={[
            {
              query: '(max-width: 768px)',
              highResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585840686/b2c-art/home-2020/digital/img_homepage_videocall_2x.jpg',
              highResImg2x: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585840689/b2c-art/home-2020/digital/img_homepage_videocall_3x.jpg',
            },
          ]}
        >
          {isDesktop && (
            <ProgressiveImage
              className="home-treatments-section__cell-image-element"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1585840680/b2c-art/home-2020/digital/img_homepage_videocall_1x.jpg"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585840686/b2c-art/home-2020/digital/img_homepage_videocall_2x.jpg"
              highResImg2x="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585840689/b2c-art/home-2020/digital/img_homepage_videocall_3x.jpg"
            />
          )}
        </ProgressiveBackgroundImage>

        <div className="home-content-section__cell home-content-section__cell-text home-content-section__cell-text--extra-padded-right">
          <div className="home-content-section__text-content home-content-section__text-content--wide">
            <h2 className="home-content-section__title home-content-section-for-digital__title">{i18n._x('The best brands, curated for you', 'Home treatments section title')}</h2>
            {brandsSectionContent}
            <Link
              className="button button--primary button--tiny-wide home-content-section__button home-content-section-for-digital__button"
              data-qa="home-tailored-section-button"
              onClick={this.onClickBrowseServices}
              to={`/${i18n.lc}/treatments`}
            >
              {i18n._x('Browse services', 'Homepage browse services button')}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default HomeTreatmentsSectionForDigital;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/digital/HomeTreatmentsSectionForDigital.jsx